import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import Animated, { interpolate, useAnimatedStyle, useSharedValue, withRepeat, withSequence, withTiming } from "react-native-reanimated";
import { useConversationContext } from "./ConversationContext";
import { View } from "./View";
var DOT_SIZE = 10;
/**
 * Renders a chat typing indicator with three animated dots. The component is
 * designed to visually indicate that a user is typing in a chat interface.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-67}
 */ export function ChatTypingIndicator(_props) {
    var receivedMessageBorderColor = useConversationContext().receivedMessageBorderColor;
    var step = useSharedValue(0);
    useEffect(function() {
        step.value = withRepeat(withSequence(withTiming(1, {
            duration: 1500
        })), -1, false);
    }, [
        step
    ]);
    var dot1 = useAnimatedStyle(function() {
        return {
            opacity: interpolate(step.value, [
                0,
                0.3,
                0.9,
                1
            ], [
                0,
                1,
                1,
                0
            ])
        };
    });
    var dot2 = useAnimatedStyle(function() {
        return {
            opacity: interpolate(step.value, [
                0.25,
                0.55,
                0.9,
                1
            ], [
                0,
                1,
                1,
                0
            ])
        };
    });
    var dot3 = useAnimatedStyle(function() {
        return {
            opacity: interpolate(step.value, [
                0.6,
                0.8,
                0.8,
                1
            ], [
                0,
                1,
                1,
                0
            ])
        };
    });
    return /*#__PURE__*/ _jsxs(View, {
        row: true,
        spacing: 8,
        style: {
            paddingVertical: 6
        },
        children: [
            /*#__PURE__*/ _jsx(Animated.View, {
                style: [
                    {
                        width: DOT_SIZE,
                        height: DOT_SIZE,
                        borderRadius: DOT_SIZE / 2,
                        backgroundColor: receivedMessageBorderColor,
                        opacity: 1
                    },
                    dot1
                ]
            }),
            /*#__PURE__*/ _jsx(Animated.View, {
                style: [
                    {
                        width: DOT_SIZE,
                        height: DOT_SIZE,
                        borderRadius: DOT_SIZE / 2,
                        backgroundColor: receivedMessageBorderColor
                    },
                    dot2
                ]
            }),
            /*#__PURE__*/ _jsx(Animated.View, {
                style: [
                    {
                        width: DOT_SIZE,
                        height: DOT_SIZE,
                        borderRadius: DOT_SIZE / 2,
                        backgroundColor: receivedMessageBorderColor
                    },
                    dot3
                ]
            })
        ]
    });
}
